// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const ListingContentWrapper = styled("div")`
	p {
		margin-bottom: 0.75rem;
	}

	strong {
		font-weight: 600;
	}

	h3 {
		font-size: 1.1rem;
		margin-bottom: 1rem;
		font-weight: bold;
	}
`;

ListingContentWrapper.displayName = "ListingContentWrapper ";

// #####################################################
